import { useEffect, useState } from "react";
import { ReactComponent as Cross } from "../../assets/images/svg/Cross.svg";
import { ReactComponent as Recall } from "../../assets/images/svg/ReCall.svg";

function Feedback02(props) {
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    console.log("-------------", props, "------------");
    setQuestions(props.questions);
  }, [props.questions]);

  const AnswesAppend = (question, event) => {
    props.setFBdata((prevState) => ({
      ...prevState,
      answers: { ...prevState.answers, [question]: event.target.value },
    }));
  };

  return (
    <>
      {questions.map((question, index) => (
        <div key={question}>
          <label className="mb-1.5 block text-sm font-medium text-gray-700">
            {question}
          </label>
          <input
            type="text"
            id="Answer"
            value={props.answers[question] || ""}
            onChange={(event) => {
              AnswesAppend(question, event);
            }}
            className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2.5 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-60"
            required
            disabled={props?.viewfb || false}
          />
        </div>
      ))}

      <div className="flex justify-between border-t border-gray-100 pt-5">
        <button
          onClick={() => {
            props.setcurrfback(props.back);
          }}
          className="rounded-full border border-gray-300 bg-white px-6 py-2.5 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 active:scale-95"
        >
          Back
        </button>

        <button
          onClick={() => {
            props.setcurrfback(props.next);
          }}
          className="rounded-full px-6 py-2.5 text-sm font-semibold text-white shadow-sm transition-transform active:scale-95"
          style={{
            backgroundImage:
              "linear-gradient(177.88deg, #AFD462 1.79%, #6BC698 49.97%, #0FB1E2 82.06%)",
          }}
        >
          Next
        </button>
      </div>
    </>
  );
}
export default Feedback02;
